<script>
import _ from 'lodash'

export default {
  name: 'DMSHome',
  data: () => ({
    valid: true,
    dmsIdRules: [
      v => !!v || 'DMS file signature is required',
      v =>
        (v &&
          _.isArray(
            v
              .toString()
              .match(
                '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\\/[a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*)?$'
              )
          )) ||
        'DMS file signature should be a UUID/FileName separated by a forward slash'
    ],
    dmsId: '',
    dmsLoader: false
  }),
  mounted() {
    this.getSelectedFromRoute()
  },
  methods: {
    getSelectedFromRoute() {
      if (
        this.$router.currentRoute.name === 'tulip-dms-file' &&
        this.$route.params.hexId &&
        this.$route.params.fileName
      ) {
        this.dmsId =
          this.$route.params.hexId + '/' + this.$route.params.fileName
      }
    }
  }
}
</script>

<template>
  <v-flex>
    <v-card>
      <v-toolbar dense card class="elevation-2">
        <v-toolbar-title class="subheading"
          >Document Management</v-toolbar-title
        >
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form
          ref="dmsForm"
          v-model="valid"
          :class="$vuetify.dark ? 'card-dark pa-2' : 'card-light pa-2'"
          lazy-validation
        >
          <v-text-field
            v-model="dmsId"
            :rules="dmsIdRules"
            clearable
            label="DMS File Signature"
            outline
            placeholder="example: 123e4567-e89b-12d3-a456-426614174000/filename"
            required
          ></v-text-field>
          <v-btn
            :disabled="!(valid && dmsId)"
            flat
            class="beez-btn text-truncate"
            :href="'/api/core/dms/read/' + dmsId"
            target="_parent"
          >
            <span class="text-truncate">Download</span>
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style scoped></style>
